export default __webpack_public_path__ + "static/media/Flip_card.d74a0cd8.svg";